<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row">
          <div class="col-lg-4 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded h-100">
              <div class="card-header dag-box">
              </div>
              <div class="card-body p-t-20 p-b-30">
                <div class="d-flex align-items-center">
                  <div class="card-icon"
                       v-if="getInfo[objIndex].Image">
                    <img :src="require(`@/assets/img/Food icons/${getInfo[objIndex].Image}`)" width="100">
                  </div>
                  <div class="card-link">
                    <a class="card-link-24 text-dag" href="#">
                      {{ getInfo[objIndex].Title }}
                    </a>
                  </div>
                </div>
                <div class="p-t-15">
                  <span v-html="getInfo[objIndex].Text"></span>
                  <div class="p-t-25 d-block">
                    <router-link class="nextbutton bg-24 text-white d-block"
                                 :to="{ name: 'info'}">
                      {{ $t('survey_back') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['info_id'],
    computed: {
      ...mapGetters([
        'getShiftClass',
        'getInfo',
      ]),
      objIndex() {
        return this.getInfo.findIndex((obj => obj.Id === this.info_id))
      },
    },
    data() {
      return {
      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/info/InfoPage.vue